import { AllLocales, LocaleString } from "models/locale";
import get from "lodash.get";
import { TranslationKey } from "models/translation";

// makes sure there is a key for every locale (uses AllLocales, doesn't matter as this is not validation phase)
export const key = (str: LocaleString) => {
  AllLocales.forEach((locale) => {
    if (str[locale] === undefined) {
      str[locale] = ""; // default to empty, better than undefined
    }
  });
  return str;
};

// gets form field error (handles nested too using lodash.get)
// returns string if there is an error, undefined if there is not
export const getError = (
  errors: any,
  name: string,
): TranslationKey | undefined => {
  const error = get(errors, name);
  if (error) {
    return (error as any).message as TranslationKey;
  }
  return undefined;
};

// gets form field error (handles nested too using lodash.get)
// returns string if there is an error, undefined if there is not
export const getTranslationError = (
  errors: any,
  name: string,
): TranslationKey[] | undefined => {
  const error = get(errors, name.split(".")[0]);
  if (error) {
    const keys = Object.keys(error);
    const errorMessages: TranslationKey[] = keys.map((key) => {
      return error[key].message as TranslationKey;
    });
    return errorMessages;
  }
  return undefined;
};
